import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { PhotoViewerPage } from '../photo-viewer/photo-viewer.page';
import { UserApiService } from '../services/user-api.service';
import Swiper from 'swiper';
@Component({
  selector: 'app-promos',
  templateUrl: './promos.page.html',
  styleUrls: ['./promos.page.scss'],
})
export class PromosPage implements OnInit {
  @ViewChild('slides') slides;
  homeSlider = {
    slidesPerView: 1.2,
    autoplay: true,
    loop: true,
    speed: 300,
    autoplayDisableOnInteraction: false,
    noSwiping: true,
    spaceBetween: 20,
  };
  homeSliderVertical = {
    slidesPerView: 2.4,
    autoplay: true,
    loop: true,
    speed: 900,
    autoplayDisableOnInteraction: false,
    noSwiping: true,
    spaceBetween: 20,
  };
  isDataLoaded=false;
  galleryImages=[]
  constructor(
    public globals:GlobalVariable,
    public server:UserApiService,
    private modalCtrl:ModalController,
    public swiper:Swiper,
  ) { 
  }

  ngOnInit() {
  }
  ngAfterViewInit() {
    this.swiper = new Swiper('.swiper-containerHor', {
      // Swiper.js options here
      slidesPerView: this.getSlidesPerView(),
    autoplay: true,
    loop: true,
    speed: 300,
    // autoplayDisableOnInteraction: false,
    noSwiping: true,
    spaceBetween: 20,
    // autoplay: {
    //   delay: 2000,

    });

  

    // for reponsiveness
    window.addEventListener('resize', () => {
      this.swiper.params.slidesPerView = this.getSlidesPerView();
      this.swiper.update();
    });
  }
  ionViewWillEnter(){
    this.get_gallery();

  }
  getSlidesPerView(): number {
    const screenWidth = window.innerWidth;
    if (screenWidth < 576) {
      return 1.2;
    } else if (screenWidth < 768) {
      return 2;
    } else if (screenWidth < 992) {
      return 3;
    } else {
      return 4;
    }
  }
  changeSlide(e) {
    // console.log("slide changed.",e);
    this.slides.startAutoplay();
  }
  get_gallery() {
    let response = this.server.gallery_list();
    response.subscribe(data => {
      this.isDataLoaded=true;
      if(data.status=='OK'){
        console.log("gallery",data);
        if(data.data){
          this.galleryImages = data.data.blogs;
        console.log("gallery",this.galleryImages);

          // this.megaImage=this.images[0].image;
        }
      }
    }, error => {
        this.globals.presentToast("Something went wrong check your internet connection.");

    });
}
async openImage(image) {
  let modal = await this.modalCtrl.create({
    component: PhotoViewerPage,
    cssClass:'galleryModal',
    componentProps: { image: image },
  });
  modal.present();
 
}
}
